import React, { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { POOL_DATA } from "../constants/constants";
import { setUser } from "slices/authSlice";
import { CognitoUserPool } from "amazon-cognito-identity-js";
import { selectCurrentUser } from "slices/authSlice";
import Spinner from "components/General-UI/Spinner";

const userPool = new CognitoUserPool(POOL_DATA);

const PrivateRoute = ({ Component, ...rest }) => {
  const currentUser = useSelector(selectCurrentUser);
  const [checkedAuth, setCheckedAuth] = useState(false);

  useEffect(() => {
    async function confirmAuth(user) {
      if (!currentUser) await setUser(user);
      setCheckedAuth(true);
    }
    let possibleUser = null;
    const theCurrentUser = userPool.getCurrentUser();
    window.efs_debug &&
      window.log("The current user: " + JSON.stringify(theCurrentUser), 2);
    if (theCurrentUser) {
      theCurrentUser.getSession((error, session) => {
        if (error) window.efs_debug && window.log("Session Error: " + error);
        else {
          window.efs_debug &&
            window.log("Session isValid: " + session.isValid());
          if (session.isValid()) possibleUser = theCurrentUser;
        }
        confirmAuth(possibleUser);
      });
    } else confirmAuth(possibleUser);
  }, [currentUser]);

  return checkedAuth ? (
    <Route
      {...rest}
      render={(props) => {
        //if we've checked for authentication a current user WILL be set, whether it is null or something else.
        return currentUser !== null || props?.match?.params?.code ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/signIn", state: { from: props.location } }}
          />
        );
      }}
    />
  ) : (
    <div className="vh-100">
      <Spinner />
    </div>
  );
};

export default PrivateRoute;
